import { CONFIG } from '../config';
import type { Bounds } from '../types';

interface EntityWithBounds {
    getBounds(): Bounds;
}

export class OneWayBullet {
    public x: number;
    public y: number;
    public width: number;
    public height: number;
    public vx: number;
    public vy: number;
    public radius: number;
    public isAlive: boolean;
    public color: string;

    constructor(
        x: number,
        y: number,
        width: number,
        height: number,
        vx: number,
        vy: number,
        radius: number = CONFIG.BULLET.RADIUS
    ) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.vx = vx;
        this.vy = vy;
        this.radius = radius;
        this.isAlive = true;
        this.color = '#FFFFFF';
    }

    /**
     * 풀링을 위한 리셋 메서드
     */
    reset(
        x: number,
        y: number,
        width: number,
        height: number,
        vx: number,
        vy: number,
        radius: number = CONFIG.BULLET.RADIUS
    ): void {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.vx = vx;
        this.vy = vy;
        this.radius = radius;
        this.isAlive = true;
        this.color = '#FFFFFF';
    }

    update(deltaTime: number, canvasWidth: number = CONFIG.CANVAS_WIDTH, canvasHeight: number = CONFIG.CANVAS_HEIGHT): void {
        this.x += this.vx * deltaTime;
        this.y += this.vy * deltaTime;

        // Remove when off screen (any direction)
        const buffer = 100;
        if (this.x < -buffer - this.width ||
            this.x > canvasWidth + buffer + this.width ||
            this.y < -buffer - this.height ||
            this.y > canvasHeight + buffer + this.height) {
            this.isAlive = false;
        }
    }

    render(ctx: CanvasRenderingContext2D): void {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fill();
    }

    getBounds(): Bounds {
        return {
            x: this.x,
            y: this.y,
            radius: this.radius
        };
    }

    // Check collision with player (circle vs circle)
    checkCollisionWithPlayer(player: EntityWithBounds): boolean {
        const playerBounds = player.getBounds();

        // Calculate distance between centers
        const dx = this.x - playerBounds.x;
        const dy = this.y - playerBounds.y;
        const distanceSquared = dx * dx + dy * dy;
        const combinedRadius = this.radius + playerBounds.radius;

        return distanceSquared < combinedRadius * combinedRadius;
    }
}
